import React from 'react';
import { CrownFilled, EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { EditIcon } from 'components/common/SVGIcon';
import { upgradeModal } from 'components/common/CheckPermissions/UpgradeSubscriptionModal';

interface Props {
  isView?: boolean;
  centreId?: string;
}

const EditBtnFallback = ({ isView, centreId }: Props) => {
  const onClickButton = () => {
    upgradeModal.open(null, centreId);
  };
  return (
    <div className="edit-action-wrapper">
      <Button
        onClick={onClickButton}
        type="primary"
        shape="circle"
        icon={isView ? <EyeOutlined /> : <EditIcon />}
      />
      <CrownFilled className="action-feature-icon" />
    </div>
  );
};

export default EditBtnFallback;
